import { BillingRecurringTypes } from "app/models/ss-api/requests/new.member.request";

export interface IUnfunishedOrderData {

    Product: string;
    Package: string;
    BillingCycleType: BillingRecurringTypes;
    RecurringAmount: number;
    SetupAmount: number;
    CCLast4: string;
    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: number;
    TaxAmount: number;

}

export class UnfunishedOrderData implements IUnfunishedOrderData {

    Product: string;
    Package: string;
    BillingCycleType: BillingRecurringTypes;
    RecurringAmount: number = 0;
    SetupAmount: number = 0;
    CCLast4: string;
    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: number;
    TaxAmount: number;

}


